import { __decorate } from "tslib";
import VueMarkdown from 'vue-markdown';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CharactersBackgroundDetail from '@/pages/Characters/CharactersBackgroundDetail.vue';
import { chain } from 'lodash';
import MySelect from '@/components/MySelect.vue';
import MyDialog from '@/components/MyDialog.vue';
const featModule = namespace('feats');
let CharacterBuilderDescription = class CharacterBuilderDescription extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.alignmentOptions = [
            'Lawful Light',
            'Neutral Light',
            'Chaotic Light',
            'Lawful Balanced',
            'Balanced Neutral',
            'Chaotic Balanced',
            'Lawful Dark',
            'Neutral Dark',
            'Chaotic Dark'
        ];
        this.characteristicsList = [
            'Personality Traits',
            'Ideal',
            'Bond',
            'Flaw',
            'Gender',
            'Place of Birth',
            'Age',
            'Height',
            'Weight',
            'Hair',
            'Eyes',
            'Skin',
            'Appearance',
            'Backstory'
        ];
    }
    created() {
        this.fetchFeats();
    }
    get backgroundChoices() {
        return [
            'Custom',
            ...chain(this.backgrounds)
                .sortBy('contentType')
                .map('name')
                .value()
        ];
    }
    get chosenBackground() {
        return this.backgrounds.find(({ name }) => name === this.currentBackground.name);
    }
    get featOptions() {
        if (this.currentBackground.name === 'Custom') {
            return this.feats
                .filter(({ prerequisite }) => !prerequisite || !prerequisite.toLowerCase().includes('level'))
                .map(({ name }) => name);
        }
        else {
            return this.chosenBackground && this.chosenBackground.featOptions.map(({ name }) => name);
        }
    }
    get featureOptions() {
        return this.backgrounds.map(({ featureName }) => featureName);
    }
    get featureText() {
        const featureData = this.backgrounds.find(({ featureName }) => featureName === this.currentBackground.feature);
        return featureData ? featureData.featureText : '';
    }
    get featText() {
        const featName = this.currentBackground.feat && this.currentBackground.feat.name;
        const featData = this.feats.find(({ name }) => name === featName);
        return featData ? featData.text : '';
    }
    handleChangeName(name) {
        this.$emit('updateCharacter', { name });
    }
    handleChangeImage(image) {
        this.$emit('updateCharacter', { image });
    }
    handleChangeCharacteristic(characteristic, newCharacteristic) {
        this.$emit('updateCharacter', { characteristics: { [characteristic]: newCharacteristic } });
    }
    handleChangeBackground(newBackground) {
        this.$emit('updateCharacter', { background: { name: newBackground, feat: { name: '' }, feature: '' } });
    }
    handleChangeBackgroundFeat(newFeat) {
        this.$emit('updateCharacter', { background: { feat: { name: newFeat || '' } } });
    }
    handleChangeBackgroundFeature(newFeature) {
        this.$emit('updateCharacter', { background: { feature: newFeature || '' } });
    }
};
__decorate([
    Prop(Array)
], CharacterBuilderDescription.prototype, "backgrounds", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderDescription.prototype, "currentBackground", void 0);
__decorate([
    Prop(String)
], CharacterBuilderDescription.prototype, "name", void 0);
__decorate([
    Prop(String)
], CharacterBuilderDescription.prototype, "image", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderDescription.prototype, "characteristics", void 0);
__decorate([
    featModule.State
], CharacterBuilderDescription.prototype, "feats", void 0);
__decorate([
    featModule.Action
], CharacterBuilderDescription.prototype, "fetchFeats", void 0);
CharacterBuilderDescription = __decorate([
    Component({
        components: {
            CharactersBackgroundDetail,
            VueMarkdown,
            MySelect,
            MyDialog
        }
    })
], CharacterBuilderDescription);
export default CharacterBuilderDescription;
